<div class="top-section service-page">

    <section class="healthcare-banner instool aashi">
        <div class="container">
            <div class="row hero-img-wrapper zmc">
                <div class="col-lg-7 col-md-7 col-sm-7  col-12 service-heading">
                    <div class="headtext">
                        <h1>Microsoft Business Control</h1>
                        <p>Microsoft offers several business management solutions that may fall under the scope of
                            your inquiry. The most relevant product to your request might be Microsoft Dynamics 365
                            Business Central, which is an all-in-one business management solution for small to
                            medium-sized businesses.</p>
                            <a class="ar_contect-industries-header" routerLink="/contact-us.html" style="cursor: pointer;"><span>Contact Us</span></a>
                          

                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                    <div class="right-img frontend-heroimg">
                        <img src="../../../assets/images/services/b-controller-1-removebg-preview.png" loading="lazy"
                            alt="Ecommerce Website Development Service Header Image">
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="services-row">
    <div class="container">
        <!-- <app-services-content-point [firstMAtchData]="firstMAtch"></app-services-content-point> -->

        <div class="softeare-developemnt-isv-main">
            <div class="row">
                <div class="col-lg-12 headingsec">
                    <h2>Project Management</h2>
                    <!-- <p>It combines the traditional Office suite of applications with advanced cloud services,
                        collaboration tools, and intelligent capabilities. Here's an overview of its functionality and
                        key features</p> -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li class="mobi">
                            <div class="img-box-isv">
                                <img style="height: 230px;"  src="../../../assets/images/services/bi-1.jpg" loading="lazy"
                                    alt="Ecommerce Application Development">

                            </div>
                        </li>
                        <li>
                            <h3>Project Planning</h3>
                            <p>Plan and track projects, including tasks and timelines.
                            </p>
                            <h3>Resource Management</h3>
                            <p>Assign and manage resources for projects.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li>
                            <h3>Budgeting and Forecasting</h3>
                            <p> Monitor budgets and project costs.</p>
                        </li>
                        <li>
                            <h3>Timesheets</h3>
                            <p>Track employee time spent on projects.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="quote-box" style="    background-color: #0d052a;">
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <h4>Are You Ready To Discuss Your Project With Us?</h4>
            </div>
            <div class="col-md-3">
                <button routerLink="/hire-react-js-developers.html">Hire Our Experts</button>
            </div>
        </div>
    </div>
</section> -->
<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Power BI Premium</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/finance.png" alt="HTML">
                        <h3>Financial Management</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/n-general.png" alt="CSS">
                        <h3>General Ledger</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/n-account.png" alt="Javascript">
                        <h3>Accounts Payable</h3>
                    </li>
                    <li>
                            <img src="../../../assets/images/services/n-account-r.png" alt="React">
                            <h3>Accounts Receivable</h3>
                        </li>
                    <!-- <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Angular">
                        <h3>Dynamics 365 Human Resources</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Vue">
                        <h3>Dynamics 365 Commerce</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Scss">
                        <h3>Dynamics 365 Project Operations</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Bootstrap">
                        <h3>Dynamics 365 Customer Service</h3>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Visualization and Reporting</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/n-visualization.png" alt="HTML">
                        <h3>Visualizations</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/n-custom.png" alt="CSS">
                        <h3>Custom Visuals</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/n-interactive.png" alt="Javascript">
                        <h3>Interactive Reports</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/n-themes.png" alt="React">
                        <h3>Themes and Formatting</h3>
                    </li>
                    <!-- <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Angular">
                        <h3>Dynamics 365 Human Resources</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Vue">
                        <h3>Dynamics 365 Commerce</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Scss">
                        <h3>Dynamics 365 Project Operations</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/load-balance-removebg-preview.png" alt="Bootstrap">
                        <h3>Dynamics 365 Customer Service</h3>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</section>




<!-- <app-why-choose-us></app-why-choose-us> -->

<section class="services-row services-row-new">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Advanced Features</h2>
                <!-- <p>Here’s what you get when you choose us as your preferred business partner:</p> -->
            </div>
        </div>
        <div class="row uses-box ">
            <div class="col-lg-7 col-md-7 col-sm-12 whychoose-isv uses-conent">
                <ul>
                    <li>
                        <h3>Microsoft 365 Integration</h3>
                        <p>Seamlessly integrates with Microsoft 365 for collaboration tools and productivity apps.
                        </p>
                    </li>
                    <li>
                        <h3>Microsoft Teams Integration</h3>
                        <p> Collaborate and communicate within Business Central using Teams.
                        </p>
                    </li>
                    <li>
                        <h3>Third-Party Integrations</h3>
                        <p> Supports integration with other third-party applications and services.</p>
                    </li>
                    <li>
                        <h3>Role-Based Access Control</h3>
                        <p>Manage permissions and access to data based on roles.</p>
                    </li>
                    <li>
                        <h3>Compliance Management</h3>
                        <p>Adhere to industry standards and regulatory requirements.
                        </p>
                    </li>
                    <li>
                        <h3>Personalization</h3>
                        <p> Customize the user interface to match individual preferences and workflows.</p>
                    </li>
                </ul>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 img-box-container img-content">
                <div class="img-box-why-chosse">
                    <img src="../../../assets/images/services/b-controller-3.jpg" loading="lazy" alt="Product Web Development">
                </div>
            </div>
        </div>
    </div>

</section>